import React, {useEffect, useState} from "react";
import moment from "moment/moment";
import {AddToCartModal} from "@/modules/front/AddToCartModal";

export const AddToCartButton = (props) => {
    let SHOW_MODAL = props.showModal ? props.showModal : false;

    const baseLink = window.links.reservation.new;

    const [showAddToCartModal, setShowAddToCartModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    let productId = props.productId;

    useEffect(() => {
        if (props.onDateConfirmed && props.startDate && props.endDate) {
            props.onDateConfirmed(props.startDate, props.endDate, props.officeId);
        }

    }, [props.startDate, props.endDate]);
    if (props.addToCartLabel === false) { // Explicitly set to false
        return;
    }

    let addToCartLabel = props.addToCartLabel ? props.addToCartLabel : window.translations.addToCart;

    if (!props.startDate || !props.endDate) {

        return (
            <div>
                <br/>
                <a type="button" className="btn btn-primary disabled">{addToCartLabel}&nbsp;&nbsp;&nbsp;<i
                    className="fas fa-chevron-right"></i></a>
                <br/>
                <br/>
            </div>
        );
    }

    const startDate = moment(props.startDate).format('YYYY-MM-DD');
    const length = moment(props.endDate).diff(moment(props.startDate), 'days') + 1;

    let url = new URL(baseLink);
    url.searchParams.append('date', startDate);
    url.searchParams.append('length', length);
    url.searchParams.append('productId', productId);
    url.searchParams.append('officeId', props.officeId);
    if (props.packageId) {
        url.searchParams.append('packageId', props.packageId);
    }
    const urlHref = url.toString();

    let aProps = {};

    if (props.onDateConfirmed) {

        aProps = {
            onClick: (e) => {
                e.preventDefault();
                setIsLoading(true);
                props.onDateConfirmed(startDate, length, props.officeId);
            }
        }
    }
    else if (SHOW_MODAL) {
        aProps = {
            onClick: (e) => {
                e.preventDefault();
                setShowAddToCartModal(true);
            }
        }
    }
    else {
        aProps = {
            href: urlHref,
            onClick: () => setIsLoading(true),
        };
    }

    const btnClass = "btn btn-primary" + (isLoading ? " disabled" : "");

    return (
        <div>
            <br/>
            <a {...aProps} type="button" className={btnClass}>
                {isLoading
                    ? <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>{addToCartLabel}</>
                    : <>{addToCartLabel}&nbsp;&nbsp;&nbsp;<i className="fas fa-chevron-right"></i></>
                }
            </a>
            <br/>
            <br/>
            {showAddToCartModal && <AddToCartModal  productId={productId}
                                                    dateFrom={startDate}
                                                    dateTo={moment(props.endDate).format('YYYY-MM-DD')}
                                                    show={showAddToCartModal} onHide={() => setShowAddToCartModal(false)} />}
        </div>
    );
}